import { combineReducers } from "redux";
import authReducer from "./authReducer";
import verificationReducer from "./verificationReducer";
import emailReducer from "./emailReducer";
import dashboardReducer from './dashboardReducer';
import userReducer from "./userReducer";
import registrationReducer from "./registrationReducer";
import docusignReducer from "./docusignReducer";
import ssoReducer from "./ssoReducer";
import ssoQueryParamsDetailsReducer from "./ssoQueryParamsDetails";
import fromLoginReducer from "./fromLoginReducer";

const appReducer = combineReducers({
  login: authReducer,
  verification: verificationReducer,
  email: emailReducer,
  dashboard: dashboardReducer,
  userData: userReducer,
  registration: registrationReducer,
  docusign: docusignReducer,
  sso:ssoReducer,
  ssoQueryParamsDetails:ssoQueryParamsDetailsReducer,
  fromLogin: fromLoginReducer
});

const rootReducer = (state, action) => {
  if (action.type === 'CLEAR_REDUX_STATE') {
    // Reset state to undefined to reinitialize all reducers to their initial state
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
